import React from "react";
import { Route } from "react-router-dom";
import lazyWithRetry from "helpers/lazyWithRetry";

const DeliveryTimelinePage = lazyWithRetry(() =>
  import("./DeliveryTimelinePage")
);

export default [
  <Route
    exact
    path="/delivery-timeline"
    key="delivery-timeline"
    component={DeliveryTimelinePage}
  />,
];
